import request from '@/utils/request'

export function getBeneficiary(status = 'all') {
  return request({
    url: '/api/beneficiary-firewall?status=' + status,
    method: 'get'
  });
}

export function getBeneficiaryCustomer() {
  return request({
    url: '/api/beneficiary-firewall/summary',
    method: 'get'
  });
}

export function getBeneficiaryCustomerByUID(uid) {
  return request({
    url: `/api/beneficiary-firewall/${uid}`,
    method: 'get'
  });
}

export function deleteBeneficiaryCustomerByUID(uid) {
  return request({
    url: `/api/beneficiary-firewall/${uid}`,
    method: 'delete'
  });
}

export function addCustomer(project_uid, data) {
  return request({
    url: `/api/beneficiary-firewall/projects/${project_uid}`,
    method: 'post',
    data: data
  });
}
export function updateStatusBeneficiary(beneficiary_id, data) {
  return request({
    url: `/api/beneficiary-firewall/beneficiarys/${beneficiary_id}/status`,
    method: 'put',
    data: data
  });
}
export function getBeneficiaryDocument(beneficiary_id) {
  return request({
    url: `/api/beneficiary-firewall/beneficiarys/${beneficiary_id}/documents`,
    method: 'get',
  });
}
